var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-panel"},[_c('panel-cards',{attrs:{"views":_vm.views,"count":_vm.count,"complains":_vm.complains}}),_c('control-panel-table',{attrs:{"articles":this.articles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }